import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import PageContainer from "../../components/PageContainer/PageContainer";
import { URLs } from "../../utils/redirectStep";
import { getSessionDocument } from "services/sessionStorageService";

function EsCliente() {
  const navigate = useNavigate();
  const location = useLocation();

  const nroTelefono = window.nroTelefono;
  const modal = {
    open: true,
    showX: true,
    message: `<p className={classes.modalMessage}><span style="color: #d00771!important">¡Usted ya es cliente Italmundo!</span><br /><br />Por otras consultas comunicarse<br />al <span class="special-font">${nroTelefono}</span><br /><br />¡Muchas gracias!</p>`,
  };

  useEffect(() => {
    const documento = getSessionDocument();
    if (!documento) {
      navigate(URLs.home);
    }
  }, []);

  const handleModalCloseClick = () => {
    window.location.href = "https://italmundo.com.uy/";
  };

  return (
    <PageContainer
      modal={modal}
      handleModalCloseClick={handleModalCloseClick}
      canonicalUrl={URLs.esCliente}
      noImage={true}
    />
  );
}

export default EsCliente;
